import './SiteFooter.css';

const EU_AI_ACT_URL = 'https://www.europarl.europa.eu/news/sv/press-room/20260427IPR42011/ai-act-deal-on-simplification-measures-ban-on-nudifier-apps';

export function SiteFooter({ onNavigate }) {
    return (
        <footer className="siteFooter">
            <div className="siteFooterTop">
                <div className="siteFooterCol siteFooterCol--brand">
                    <span className="siteFooterLogo" onClick={() => onNavigate('landing')}>D33P</span>
                    <p className="siteFooterTagline">AI NSFW tool — fully synthetic videos and photos, generated from prompts. No uploads accepted.</p>
                    <p className="siteFooterAge">18+ · Synthetic content only</p>
                </div>

                <div className="siteFooterCol">
                    <span className="siteFooterColTitle">Product</span>
                    <button className="siteFooterLink" onClick={() => onNavigate('video')}>Generate video</button>
                    <button className="siteFooterLink" onClick={() => onNavigate('photo')}>Generate photo</button>
                    <button className="siteFooterLink" onClick={() => onNavigate('gallery')}>Gallery</button>
                </div>

                <div className="siteFooterCol">
                    <span className="siteFooterColTitle">Legal</span>
                    <button className="siteFooterLink" onClick={() => onNavigate('terms')}>Terms of Service</button>
                    <button className="siteFooterLink" onClick={() => onNavigate('privacy')}>Privacy Policy</button>
                    <button className="siteFooterLink" onClick={() => onNavigate('compliance')}>18 U.S.C. § 2257</button>
                    <button className="siteFooterLink" onClick={() => onNavigate('contact')}>Contact</button>
                </div>

                <div className="siteFooterCol siteFooterCol--compliance">
                    <span className="siteFooterColTitle">Compliance</span>
                    <span className="siteFooterBadge">
                        <span className="siteFooterBadgeDot" />
                        EU AI Act compliant
                    </span>
                    <a
                        className="siteFooterLink"
                        href={EU_AI_ACT_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Ban on nudifier apps →
                    </a>
                    <span className="siteFooterFine">No undress / nudifier features</span>
                </div>
            </div>

            <div className="siteFooterBottom">
                <span>© D33P · 2026</span>
                <span className="siteFooterBottomDot">·</span>
                <span>For adults 18+</span>
                <span className="siteFooterBottomDot">·</span>
                <span>All content is AI-generated, no real persons depicted</span>
            </div>
        </footer>
    );
}
